import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrow4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M21.454 16.402 14.499 4.357c-1.136-1.99-4.008-1.99-5.14 0L2.4 16.402c-1.136 1.99.278 4.462 2.57 4.462h13.89c2.292 0 3.73-2.496 2.595-4.462Zm-9.53 1.79a1.116 1.116 0 0 1-1.106-1.107c0-.605.502-1.108 1.107-1.108s1.107.503 1.083 1.136c.028.576-.503 1.08-1.083 1.08Zm1.01-7.159c-.049.858-.102 1.712-.151 2.57-.024.278-.024.532-.024.805a.834.834 0 0 1-.834.805.816.816 0 0 1-.834-.78c-.073-1.336-.15-2.648-.224-3.984-.025-.351-.05-.707-.078-1.058 0-.58.327-1.059.858-1.21a1.11 1.11 0 0 1 1.287.63c.078.175.102.35.102.555-.024.56-.077 1.116-.102 1.667Z"
    />
  </svg>
);
export default SvgArrow4;
